// Services
import modal from "./modal";
import screen from "./screen";
import loader from "./loader";
import settings from "./settings";
import messages from "./messages";
import timer from "pages/Timer/reducer";

// Pages
import auth from "pages/Auth/reducer";
import main from "pages/Main/reducer";
import orders from "pages/Orders/reducer";
import search from "pages/Search/reducer";
import account from "pages/Account/reducer";
import pfizer from "../pages/Pfizer/reducer";
import checkout from "pages/Checkout/reducer";
import projects from "pages/Projects/reducer";
import thesaurus from "pages/Thesaurus/reducer";
import libraries from "pages/Libraries/reducer";
import contactUs from "pages/ContactUs/reducer";
import requestForm from "pages/RequestForm/reducer";
import resetPassword from "pages/ResetPassword/reducer";
import forgotPassword from "pages/ForgotPassword/reducer";
import chemicalProbes from "pages/ChemicalProbes/reducer";
import moleculeProduct from "pages/MoleculeProduct/reducer";
import librariesProduct from "pages/LibrariesProduct/reducer";
import impuritiesForDrug from "pages/ImpuritiesForDrug/reducer";
import allDrugsVocabulary from "pages/AllDrugsVocabulary/reducer";
import librariesCompounds from "pages/LibrariesCompounds/reducer";

const rootReducer = {
  main: main,
  auth: auth,
  timer: timer,
  modal: modal,
  pfizer: pfizer,
  loader: loader,
  screen: screen,
  search: search,
  orders: orders,
  account: account,
  checkout: checkout,
  messages: messages,
  projects: projects,
  settings: settings,
  thesaurus: thesaurus,
  contactUs: contactUs,
  libraries: libraries,
  requestForm: requestForm,
  resetPassword: resetPassword,
  forgotPassword: forgotPassword,
  chemicalProbes: chemicalProbes,
  moleculeProduct: moleculeProduct,
  librariesProduct: librariesProduct,
  impuritiesForDrug: impuritiesForDrug,
  allDrugsVocabulary: allDrugsVocabulary,
  librariesCompounds: librariesCompounds,
};

export default rootReducer;
